<template>
  <div>
    <h2 class="diviser">
      Partes
    </h2>

    <div class="m-t">
      Partes não cadastradas <!-- @TODO 2.0.2 -->
    </div>
  </div>
</template>

<script>
import CadastroBemMixin from "@/components/bem/components/include/CadastroBemMixin"

export default {
  name: "BemProcessoPartes",
  components: {
  },
  mounted() {
  },
  mixins: [CadastroBemMixin],
  data() {
    return {}
  },
  watch: {
  },
  computed: {},
  methods: {
  }
}
</script>
